import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PinCode from './PinCode';
import { useAppContext } from '../../context/context';
import LoadingButton from '@mui/lab/LoadingButton';
import { useFetch } from '../../hooks/useFetch';
import { loginMfaUrl } from '../../constants';
import ResendMfa from './ResendMfa';
import { useNavigate } from 'react-router-dom';
import { getUser } from '../../util/getUser';
import { User } from '@sm-dashboard/reshet-types';
import { queryClient } from '@/react-query';

const LoginMfa = ({ phone, secret, isWhatsApp }: { phone: string; secret: string; isWhatsApp: boolean }) => {
  const [readyPinCode, setReadyPinCode] = useState<boolean>(false);
  const [errorTxt, setErrorTxt] = useState<string>('');
  const [pinCode, setPinCode] = useState<string>('');
  const [errCode, setErrCode] = useState<string>('');
  const { selectedNav, setUser } = useAppContext();

  const navigate = useNavigate();
  const { data, error, loading, fetchData } = useFetch();
  const [reSecret, setReSecret] = useState<string | null>(null);

  const getAppCookie = () => {
    const value = '; ' + document.cookie;
    const parts = value.split('; ' + 'appUserToken' + '=');
    if (parts.length == 2) return parts?.pop()?.split(';')?.shift() || null;
  };

  const token = localStorage.getItem('appUserToken') || getAppCookie();

  const onLogin = () => {
    const { token, delta } = data;
    localStorage.setItem('reshet-token', token);
    const user = getUser();
    setUser(user);
    queryClient.invalidateQueries();
    user && userIsAppMode(user);
    if (selectedNav?.link) {
      navigate(selectedNav.link);
    } else if (
      window.localStorage.getItem('redirect') &&
      window.localStorage.getItem('redirect') !== '/login-mfa' &&
      window.localStorage.getItem('redirect') !== '/register'
    ) {
      navigate(window.localStorage.getItem('redirect') as string);
    } else {
      navigate('/kindergarten-leads');
    }
  };

  const userIsAppMode = async (user: User) => {
    if (token) {
      const xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function () {
        if (this.readyState == 4) {
          if (this.status == 200) {
            console.log(xhttp.responseText);
          } else {
            console.error('Failed to send request: ' + this.status);
          }
        }
      };

      xhttp.open('POST', (import.meta as any).env.VITE_WEB2APPLICATION_API_URL, true);
      xhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      xhttp.send(
        'api_domain=' +
          encodeURIComponent((import.meta as any).env.VITE_WEB2APPLICATION_API_DOMAIN) +
          '&api_key=' +
          encodeURIComponent((import.meta as any).env.VITE_WEB2APPLICATION_API_KEY) +
          '&token=' +
          encodeURIComponent(token) +
          '&email=' +
          encodeURIComponent(`${user.phone}@chabadisrael.co.il`) +
          '&id=' +
          '605' +
          '&app_id=1'
      );
    }
  };

  const handleSubmit = () => {
    if (!readyPinCode) {
      setErrCode('error');
      return;
    }
    setErrCode('');
    fetchData({
      method: 'POST',
      url: loginMfaUrl,
      data: {
        secret: reSecret ? reSecret : secret,
        otp: pinCode,
        phone,
        isAppMode: token ? true : false
      }
    });
  };

  useEffect(() => {
    if (readyPinCode) {
      fetchData({
        method: 'POST',
        url: loginMfaUrl,
        data: {
          secret: reSecret ? reSecret : secret,
          otp: pinCode,
          phone,
          isAppMode: token ? true : false
        }
      });
    }
  }, [pinCode]);
  useEffect(() => {
    if (data) {
      onLogin();
    }
    if (error) {
      setErrCode('error');
      setErrorTxt('קוד לא תואם למספר שנשלח');
    }
  }, [data, error]);
  return (
    <>
      <Typography sx={{ marginTop: 1 }} component="h1" variant="subtitle1" color="text.primary">
        {isWhatsApp ? 'הכנס קוד שנשלח לוואטסאפ' : 'הכנס קוד שנשלח למספר טלפון'}
      </Typography>

      <Box sx={{ mt: 3, mb: 2 }}>
        <PinCode
          length={6}
          onChange={value => setReadyPinCode(value.length === 6)}
          onComplete={value => setPinCode(value)}
          onError={errCode}
          direction="rtl"
        />
      </Box>
      <Typography>קוד נשלח למספר ****{phone?.slice(0, phone?.length - 4)}</Typography>

      <LoadingButton
        data-testid="login-button-mfa"
        type="submit"
        onClick={() => handleSubmit()}
        variant="contained"
        sx={{ mt: 3, width: '90%' }}
        loading={loading}
      >
        כניסה{' '}
      </LoadingButton>

      {errorTxt && (
        <>
          <Typography sx={{ marginTop: 1 }} component="h1" variant="subtitle2" color="primary">
            {errorTxt}
          </Typography>
          <ResendMfa phone={phone} setReSecret={setReSecret} isWhatsApp={isWhatsApp} />
        </>
      )}
    </>
  );
};

export default LoginMfa;
